module.exports = __webpack_public_path__ + "static/media/keyboard_arrow_right-24px.7f12c519.svg";